/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const trashFilled = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M19 5v2H5V5h3V4a2 2 0 012-2h4a2 2 0 012 2v1h3zM6.187 8h11.625l-.695 11.125A2 2 0 0115.121 21H8.879a2 2 0 01-1.996-1.875L6.187 8zM14 5h-4V4h4v1z"
		/>
	</SVG>
);

export default trashFilled;
